export function findCard(state) {
  return (id) => state.all.find(((v) => v.id === id));
}

export function findCardByType(state) {
  return (type) => state.all.find(((v) => v.type === type));
}

export function findTransferCardByType(state) {
  return (type) => state.transferCards.find(((v) => v.type === type));
}
